import InsurancePurchaseStep from '../insurance-purchase-step/insurance-purchase-step.component';
import { ReactComponent as MagnifierImg } from '../../assets/icons/search.svg';
import { ReactComponent as ComparisonImg } from '../../assets/icons/compare.svg';
import { ReactComponent as DoubleUsersImg } from '../../assets/icons/people.svg';
import { ReactComponent as ChecklistImg } from '../../assets/icons/doc.svg';
import {
  Container,
  Box,
  useTheme,
  Typography,
  Divider,
  useMediaQuery,
} from '@mui/material';

const steps = [
  {
    title: '1. Cotação',
    text: 'Insira as informações da sua viagem.',
    logoUrl: MagnifierImg,
  },
  {
    title: '2. Comparação',
    text: 'Compare coberturas, preços e seguradoras e escolha o seguro ideal para você.',
    logoUrl: ComparisonImg,
  },
  {
    title: '3. Informações do Viajante',
    text: 'Insira as informações completas dos viajantes.',
    logoUrl: DoubleUsersImg,
  },
  {
    title: '4. Pagamento e Recebimento',
    text: 'Efetue o pagamento e receba a sua apólice via e-mail e WhatsApp.',
    logoUrl: ChecklistImg,
  },
];

const InsurancePurchaseTutorial = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container
      maxWidth={'lg'}
      sx={{
        padding: `${theme.spacingValues.large} ${theme.spacingValues.medium}`,
        borderRadius: {
          xs: `${theme.spacingValues.medium}`,
          md: `${theme.spacingValues.large}`,
        },
        backgroundColor: `${theme.palette.background.paper}`,
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: '1fr',
          md: '1fr 1fr 1fr',
        }}
        gap={theme.spacingValues.medium}
      >
        {/* Lado Esquerdo */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: theme.spacingValues.medium,
          }}
        >
          <Box
            sx={{
              borderRadius: '10px',
              margin: `${theme.spacingValues.small}`,
              padding: `${theme.spacingValues.small} ${theme.spacingValues.medium}`,
              backgroundColor: `${theme.palette.grey[50]}`,
            }}
          >
            <Typography sx={{ color: `${theme.palette.primary.main}` }}>
              4 passos
            </Typography>
          </Box>
          <Typography
            variant="h2"
            sx={{
              textAlign: { xs: 'center', md: 'inherit' },
              maxWidth: { xs: '80%', md: 'inherit' },
            }}
          >
            Para contratar o seguro viagem
          </Typography>
        </Box>

        {/* Lado Direito */}
        <Box
          sx={{
            gridColumn: 'span 2',
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: theme.spacingValues.large,
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '150px',
              }}
            >
              <InsurancePurchaseStep {...step} />
              {/* Divisória Condicional */}
              {(index === 0 || index === 1 || (index === 2 && isMobile)) && (
                <Divider
                  sx={{
                    borderColor: theme.palette.grey[50],
                    borderStyle: 'dashed',
                    width: '100%',

                    borderWidth: '1.8px',
                    margin: `${theme.spacingValues.medium} 0`,
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default InsurancePurchaseTutorial;
